import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { ITVBetDTO, ITVBetGetToken } from '../../types/interfaces/LiveCasino/TVBetDTO';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IGetGameUrl } from '../../types/slot';

import { shortLanguages } from 'services/locale';
import { tvbetClientId, tvbetFrameUrl } from './utils';
import { getCategories } from '../../utils/liveCasinoSort';
import { CasinoType } from 'modules/Casino/types/configuration';

export class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<ITVBetDTO[]>): ISlotViewItem[] =>
    data.map((item: ITVBetDTO) => ({
      id: String(item.code),
      gameId: String(item.code),
      gameName: item.name,
      provider: 'tvBet',
      description: item.name,
      routeProvider: 'tvBet',
      type: CasinoType.liveCasino,
      imageUrl: `/images/tvbet/${item.img}`,
      tab: getCategories(item.name, item.code.toString(), 'tvBet'),
    }));

  convertGameUrl = ({ data, lang, gameId }: IGetGameUrl<ITVBetGetToken, unknown>) =>
    `https://${tvbetFrameUrl}/?lng=${shortLanguages[lang as keyof typeof shortLanguages]}&tokenAuth=${
      data.token
    }&clientId=${tvbetClientId}&singleGame=${gameId}`;
}

export default Converter;
